(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["1st-listicle"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('calmyr-article')) return;
  class CalmyrArticle extends HTMLElement {
    connectedCallback() {
      this.prog = this.querySelector('.cla__prog');
      this.final = this.querySelector('[data-final]');
      this.onScroll = () => {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = null;
          const doc = document.documentElement;
          const max = doc.scrollHeight - innerHeight;
          const p = max > 0 ? Math.min(1, Math.max(0, scrollY / max)) : 0;
          if (this.prog) this.prog.style.setProperty('--p', p.toFixed(4));
          let show = scrollY > innerHeight * 0.6;
          if (this.final) {
            const r = this.final.getBoundingClientRect();
            if (r.top < innerHeight && r.bottom > 0) show = false;
          }
          const legal = this.querySelector('.cla__legal');
          if (legal && legal.getBoundingClientRect().top < innerHeight - 40) show = false;
          this.classList.toggle('is-sticky', show);
        });
      };
      addEventListener('scroll', this.onScroll, { passive: true });
      addEventListener('resize', this.onScroll, { passive: true });
      this.onScroll();

      if (!('IntersectionObserver' in window)) return;
      this.classList.add('js');
      this.io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) { e.target.classList.add('is-in'); this.io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px' });
      this.querySelectorAll('.cla__up').forEach((el) => this.io.observe(el));
    }
    disconnectedCallback() {
      removeEventListener('scroll', this.onScroll);
      removeEventListener('resize', this.onScroll);
      if (this.io) this.io.disconnect();
    }
  }
  customElements.define('calmyr-article', CalmyrArticle);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alive-promise"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('calmyr-alive-promise')) return;
  class CalmyrAlivePromise extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('.cap__q button').forEach((btn) => {
        btn.addEventListener('click', () => this.toggle(btn.closest('.cap__qa')));
      });
      document.addEventListener('shopify:block:select', this.onSelect = (e) => {
        const qa = e.target.closest && e.target.closest('.cap__qa');
        if (qa && this.contains(qa) && !qa.classList.contains('is-open')) this.toggle(qa);
      });
      if (!('IntersectionObserver' in window)) return;
      this.classList.add('js');
      this.io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) { e.target.classList.add('is-in'); this.io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px' });
      this.querySelectorAll('.cap__up, .cap__cert').forEach((el) => this.io.observe(el));
    }
    toggle(qa) {
      const open = !qa.classList.contains('is-open');
      qa.classList.toggle('is-open', open);
      qa.querySelector('.cap__q button').setAttribute('aria-expanded', open);
    }
    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.onSelect) document.removeEventListener('shopify:block:select', this.onSelect);
    }
  }
  customElements.define('calmyr-alive-promise', CalmyrAlivePromise);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calmyr-about"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('calmyr-about')) return;
  class CalmyrAbout extends HTMLElement {
    connectedCallback() {
      if (!('IntersectionObserver' in window)) return;
      this.classList.add('js');
      this.io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) { e.target.classList.add('is-in'); this.io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -10% 0px' });
      this.querySelectorAll('.cab__up').forEach((el) => this.io.observe(el));
    }
    disconnectedCallback() { if (this.io) this.io.disconnect(); }
  }
  customElements.define('calmyr-about', CalmyrAbout);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calmyr-care-guide"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('calmyr-care')) return;
  class CalmyrCare extends HTMLElement {
    connectedCallback() {
      this.setupChips();
      if (!('IntersectionObserver' in window)) return;
      this.classList.add('js');
      const els = this.querySelectorAll('.ccg__up, .ccg__tl, .ccg__art');
      this.io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            this.io.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -10% 0px' });
      els.forEach((el) => this.io.observe(el));
    }
    disconnectedCallback() {
      if (this.io) this.io.disconnect();
    }
    setupChips() {
      const tabs = [...this.querySelectorAll('.ccg__chip')];
      if (!tabs.length) return;
      const select = (tab, focus) => {
        tabs.forEach((t) => {
          const on = t === tab;
          t.setAttribute('aria-selected', on);
          t.tabIndex = on ? 0 : -1;
          const panel = this.querySelector('#' + t.getAttribute('aria-controls'));
          if (!panel) return;
          if (on && panel.hidden) {
            panel.hidden = false;
            panel.classList.remove('is-enter');
            void panel.offsetWidth;
            panel.classList.add('is-enter');
          } else if (!on) {
            panel.hidden = true;
          }
        });
        if (focus) tab.focus();
      };
      tabs.forEach((t, i) => {
        t.addEventListener('click', () => select(t, false));
        t.addEventListener('keydown', (e) => {
          let n = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = tabs[(i + 1) % tabs.length];
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = tabs[(i - 1 + tabs.length) % tabs.length];
          if (e.key === 'Home') n = tabs[0];
          if (e.key === 'End') n = tabs[tabs.length - 1];
          if (n) { e.preventDefault(); select(n, true); }
        });
      });
      // theme editor: selecting a symptom block shows its answer
      document.addEventListener('shopify:block:select', (e) => {
        const tab = tabs.find((t) => t === e.target);
        if (tab) select(tab, false);
      });
    }
  }
  customElements.define('calmyr-care', CalmyrCare);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calmyr-closing"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('calmyr-closing')) return;
  class CalmyrClosing extends HTMLElement {
    connectedCallback() {
      if (!('IntersectionObserver' in window)) return;
      this.classList.add('js');
      // reveal once; keep the gentle float running only while the band is on screen
      this.io = new IntersectionObserver((entries) => {
        const on = entries[0].isIntersecting;
        if (on) this.classList.add('is-in');
        this.classList.toggle('is-live', on);
      }, { rootMargin: '0px 0px -12% 0px' });
      this.io.observe(this);
    }
    disconnectedCallback() {
      if (this.io) this.io.disconnect();
    }
  }
  customElements.define('calmyr-closing', CalmyrClosing);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calmyr-compare"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (customElements.get('calmyr-compare')) return;
  class CalmyrCompare extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) return;
      var self = this;
      this.count = this.querySelector('[data-count]');
      this.total = parseInt(this.dataset.total, 10) || 0;
      this.classList.add('is-pre');
      if (this.count) this.count.textContent = '0';
      this.io = new IntersectionObserver(function (entries) {
        if (!entries.some(function (e) { return e.isIntersecting; })) return;
        self.io.disconnect();
        self.play();
      }, { threshold: 0.3 });
      this.io.observe(this.querySelector('.cmp__tbl') || this);
    }
    play() {
      var self = this;
      this.classList.add('is-in');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { self.classList.remove('is-pre'); });
      });
      /* the Calmyr score ticks up as each check mark lands */
      if (!this.count) return;
      this.timers = [];
      for (var i = 1; i <= this.total; i++) {
        (function (n) {
          self.timers.push(setTimeout(function () { self.count.textContent = String(n); }, (n - 1) * 110 + 260));
        })(i);
      }
    }
    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      (this.timers || []).forEach(clearTimeout);
      if (this.count) this.count.textContent = String(this.total);
      this._ready = false;
    }
  }
  customElements.define('calmyr-compare', CalmyrCompare);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calmyr-contact"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('calmyr-contact')) return;
  class CalmyrContact extends HTMLElement {
    connectedCallback() {
      const form = this.querySelector('form');
      const btn = this.querySelector('.cct__send');
      if (form && btn) form.addEventListener('submit', () => btn.classList.add('is-busy'));
      // after a post Shopify reloads the page: bring the result into view
      const done = this.querySelector('.cct__done, .cct__err');
      if (done) {
        done.scrollIntoView({ block: 'center' });
        if (done.classList.contains('cct__done')) done.focus({ preventScroll: true });
      }
      if (!('IntersectionObserver' in window) || done) return;
      this.classList.add('js');
      this.io = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;
        this.classList.add('is-in');
        this.timer = setTimeout(() => this.classList.add('is-typed'), 1400);
        this.io.disconnect();
      }, { threshold: 0.15 });
      this.io.observe(this);
    }
    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      clearTimeout(this.timer);
    }
  }
  customElements.define('calmyr-contact', CalmyrContact);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calmyr-faq"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('calmyr-faq')) return;
  const reduce = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class CalmyrFaq extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('[data-panel]');
      this.list = this.querySelector('[data-list]');
      if (!this.list) return;
      this.items = [...this.list.querySelectorAll('[data-item]')];
      this.single = this.dataset.single === 'true';
      this.openFirst = this.dataset.openFirst === 'true';
      this.classList.add('js');
      this.mark();

      this.list.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-toggle]');
        if (btn) this.toggle(btn.closest('[data-item]'));
      });
      this.querySelectorAll('.cfq__chip').forEach((chip) =>
        chip.addEventListener('click', () => this.show(chip))
      );

      if (reduce() || !('IntersectionObserver' in window)) {
        this.classList.add('is-in');
      } else {
        this.io = new IntersectionObserver((en) => {
          if (en.some((x) => x.isIntersecting)) {
            this.classList.add('is-in');
            this.io.disconnect();
          }
        }, { rootMargin: '0px 0px -10% 0px' });
        this.io.observe(this.list);
      }
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      clearTimeout(this.t1);
      clearTimeout(this.t2);
    }

    visible() { return this.items.filter((i) => !i.hidden); }

    // no top line on the first visible row, stagger index for the rest
    mark() {
      this.visible().forEach((it, n) => {
        it.classList.toggle('is-first', n === 0);
        it.style.setProperty('--i', Math.min(n, 8));
      });
    }

    setOpen(item, open) {
      item.classList.toggle('is-open', open);
      item.querySelector('[data-toggle]').setAttribute('aria-expanded', String(open));
    }

    toggle(item) {
      const open = !item.classList.contains('is-open');
      if (open && this.single) this.items.forEach((i) => i !== item && this.setOpen(i, false));
      this.setOpen(item, open);
    }

    show(chip) {
      if (chip.getAttribute('aria-pressed') === 'true') return;
      this.querySelectorAll('.cfq__chip').forEach((c) => c.setAttribute('aria-pressed', String(c === chip)));
      const topic = chip.dataset.topic;
      const apply = () => {
        this.items.forEach((it) => {
          it.hidden = !(topic === '' || it.dataset.topic === '' || it.dataset.topic === topic);
          this.setOpen(it, false);
        });
        const first = this.visible()[0];
        if (first && this.openFirst) this.setOpen(first, true);
        this.mark();
      };
      clearTimeout(this.t1);
      clearTimeout(this.t2);
      if (reduce()) { apply(); return; }

      const p = this.panel;
      p.style.height = p.offsetHeight + 'px';
      this.list.classList.add('is-out');
      this.t1 = setTimeout(() => {
        apply();
        // measure the new size with answers already at their final state
        this.list.querySelectorAll('.cfq__a').forEach((a) => (a.style.transition = 'none'));
        const to = this.list.offsetHeight + parseFloat(getComputedStyle(p).paddingTop) + parseFloat(getComputedStyle(p).paddingBottom);
        this.list.querySelectorAll('.cfq__a').forEach((a) => (a.style.transition = ''));
        p.classList.add('is-sizing');
        p.style.height = to + 'px';
        requestAnimationFrame(() => this.list.classList.remove('is-out'));
        this.t2 = setTimeout(() => {
          p.classList.remove('is-sizing');
          p.style.height = '';
        }, 460);
      }, 150);
    }
  }
  customElements.define('calmyr-faq', CalmyrFaq);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calmyr-header"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('calmyr-header')) return;
  const reduce = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class CalmyrHeader extends HTMLElement {
    connectedCallback() {
      this.ann = this.querySelector('[data-ann]');
      this.bar = this.querySelector('[data-bar]');
      this.sheet = this.querySelector('[data-sheet]');
      this.panel = this.querySelector('[data-panel]');
      this.openBtn = this.querySelector('[data-open]');
      this.annH = parseFloat(this.dataset.annH) || 0;
      this.ac = new AbortController();
      const sig = { signal: this.ac.signal };

      // scrolled state: fold the announcement, add a shadow, keep --sticky-header-height in sync
      this.mode = this.dataset.sticky || 'always';
      this.lastY = window.scrollY;
      this.onScroll = () => {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = 0;
          const y = window.scrollY;
          this.classList.toggle('is-scrolled', y > Math.max(24, this.annH));
          this.updateSolid();
          if (this.mode === 'up') {
            const dy = y - this.lastY;
            const full = this.annH + this.bar.offsetHeight;
            if (y <= full || this.isOpen) this.classList.remove('is-hidden');
            else if (dy > 6) this.classList.add('is-hidden');
            else if (dy < -6) this.classList.remove('is-hidden');
            if (Math.abs(dy) > 6 || y <= full) this.lastY = y;
          }
          this.syncHeight();
        });
      };
      window.addEventListener('scroll', this.onScroll, { passive: true, ...sig });
      window.addEventListener('resize', () => this.syncHeight(), sig);
      this.onScroll();
      this.syncHeight();

      this.rotate();

      // cart: open the theme drawer if it exists, otherwise follow the link to /cart
      this.querySelectorAll('[data-cart]').forEach((a) => a.addEventListener('click', (e) => {
        const drawer = document.getElementById('CartDrawer');
        if (drawer && typeof drawer.show === 'function') {
          e.preventDefault();
          drawer.show(a);
        }
      }, sig));
      const cnt = this.querySelector('.cmh__cnt');
      document.addEventListener('cart:updated', () => {
        if (!cnt || reduce()) return;
        cnt.classList.remove('is-bump'); void cnt.offsetWidth; cnt.classList.add('is-bump');
      }, sig);

      // bottom sheet
      if (this.openBtn) this.openBtn.addEventListener('click', () => this.open(), sig);
      this.querySelectorAll('[data-close]').forEach((el) => el.addEventListener('click', () => this.close(), sig));
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && this.isOpen) this.close(); }, sig);
      this.sheet && this.sheet.querySelectorAll('.cmh__list a, .cmh__scta').forEach((a) => a.addEventListener('click', () => this.close(true), sig));
      this.setupDrag(sig);
    }

    disconnectedCallback() {
      this.ac.abort();
      clearInterval(this.timer);
      cancelAnimationFrame(this.raf);
      document.documentElement.style.removeProperty('overflow');
    }

    // visible header height (strip part that is still on screen + bar), for the theme's sticky elements
    // see-through header: solid once the hero (photo area) no longer sits under the bar
    updateSolid() {
      if (!this.classList.contains('cmh--over')) return;
      const sel = this.dataset.overTarget;
      if (sel && !this.target) this.target = document.querySelector(sel);
      let solid;
      if (this.target) {
        const barBottom = Math.max(0, this.annH - window.scrollY) + this.bar.offsetHeight;
        solid = this.target.getBoundingClientRect().bottom <= barBottom + 1;
      } else {
        solid = window.scrollY > Math.max(24, this.annH);
      }
      this.classList.toggle('is-solid', solid);
    }

    // --cmh-gone: how much of the bar is off screen (used by the see-through product hero)
    syncHeight() {
      const y = window.scrollY;
      const bar = this.bar.offsetHeight;
      let gone = 0;
      if (this.mode === 'none') gone = Math.min(bar, Math.max(0, y - this.annH));
      else if (this.classList.contains('is-hidden')) gone = bar;
      const h = Math.round(Math.max(0, this.annH - y) + bar - gone);
      const root = document.documentElement.style;
      if (h !== this.lastH) { this.lastH = h; root.setProperty('--sticky-header-height', h + 'px'); }
      if (gone !== this.lastGone) { this.lastGone = gone; root.setProperty('--cmh-gone', gone + 'px'); }
    }

    rotate() {
      const msgs = this.ann ? [...this.ann.querySelectorAll('.cmh__msg')] : [];
      const dots = this.ann ? [...this.ann.querySelectorAll('.cmh__dots i')] : [];
      const secs = parseFloat(this.dataset.rotate) || 4;
      if (msgs.length < 2 || reduce()) return;
      let i = 0;
      this.timer = setInterval(() => {
        if (document.hidden || window.scrollY > this.annH) return;
        const prev = msgs[i];
        i = (i + 1) % msgs.length;
        prev.classList.remove('is-on'); prev.classList.add('is-out');
        setTimeout(() => prev.classList.remove('is-out'), 450);
        msgs[i].classList.add('is-on');
        dots.forEach((d, n) => d.classList.toggle('is-on', n === i));
      }, secs * 1000);
    }

    get isOpen() { return this.sheet && !this.sheet.hidden; }

    open() {
      if (!this.sheet || this.isOpen) return;
      this.sheet.hidden = false;
      this.sheet.style.removeProperty('--cmh-drag');
      document.documentElement.style.overflow = 'hidden';
      this.openBtn.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(() => requestAnimationFrame(() => this.sheet.classList.add('is-open')));
      const first = this.sheet.querySelector('.cmh__list a, .cmh__x');
      if (first) setTimeout(() => first.focus({ preventScroll: true }), 60);
    }

    close(instant) {
      if (!this.isOpen) return;
      const done = () => {
        this.sheet.hidden = true;
        this.sheet.classList.remove('is-closing', 'is-dragging');
        this.sheet.style.removeProperty('--cmh-drag');
        document.documentElement.style.removeProperty('overflow');
        this.openBtn.setAttribute('aria-expanded', 'false');
        if (!instant) this.openBtn.focus({ preventScroll: true });
      };
      this.sheet.classList.add('is-closing');
      this.sheet.classList.remove('is-open');
      if (reduce() || instant) { done(); return; }
      setTimeout(done, 300);
    }

    // drag the sheet down by its handle to dismiss
    setupDrag(sig) {
      const grab = this.querySelector('[data-grab]');
      if (!grab) return;
      let y0 = null, dy = 0, t0 = 0;
      grab.addEventListener('pointerdown', (e) => {
        y0 = e.clientY; dy = 0; t0 = performance.now();
        grab.setPointerCapture(e.pointerId);
        this.sheet.classList.add('is-dragging');
      }, sig);
      grab.addEventListener('pointermove', (e) => {
        if (y0 === null) return;
        dy = Math.max(0, e.clientY - y0);
        this.sheet.style.setProperty('--cmh-drag', dy + 'px');
      }, sig);
      const end = () => {
        if (y0 === null) return;
        const v = dy / Math.max(1, performance.now() - t0);
        y0 = null;
        this.sheet.classList.remove('is-dragging');
        if (dy > 120 || v > 0.6) this.close();
        else this.sheet.style.removeProperty('--cmh-drag');
      };
      grab.addEventListener('pointerup', end, sig);
      grab.addEventListener('pointercancel', end, sig);
    }
  }
  customElements.define('calmyr-header', CalmyrHeader);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calmyr-hero-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('calmyr-hero')) {
    class CalmyrHero extends HTMLElement {
      connectedCallback() {
        const json = this.querySelector('[data-ch-json]');
        if (!json) return;
        this.data = JSON.parse(json.textContent);
        this.form = this.querySelector('form');
        this.idInput = this.querySelector('[data-ch-id]');
        this.cta = this.querySelector('[data-ch-cta]');
        this.dock = this.querySelector('[data-ch-dock]');
        this.ctx = this.querySelector('[data-ch-ctx]');
        this.giftBox = this.querySelector('[data-ch-gift]');
        this.note = this.querySelector('[data-ch-note]');
        this.giftPanel = this.querySelector('[data-ch-gift-panel]');
        this.errorEl = this.querySelector('[data-ch-error]');
        this.statusEl = this.querySelector('[data-ch-status]');

        this.resolveOptions();
        this.state = this.stateFromVariant(Number(this.idInput.value));

        this.querySelectorAll('[data-ch-world]').forEach((btn) => {
          btn.addEventListener('click', () => this.pickWorld(Number(btn.dataset.chWorld)));
        });
        this.querySelectorAll('[data-ch-set]').forEach((btn) => {
          btn.addEventListener('click', () => this.pickSet(btn.dataset.chSet));
        });
        if (this.giftBox) {
          this.giftBox.addEventListener('change', () => this.onGift());
        }
        this.onSubmit = this.onSubmit.bind(this);
        this.form.addEventListener('submit', this.onSubmit);

        const buy = this.querySelector('[data-ch-buy]');
        if (buy && 'IntersectionObserver' in window) {
          this.io = new IntersectionObserver((entries) => {
            const landed = entries[0].isIntersecting;
            this.ctx.classList.toggle('is-landed', landed);
            this.dock.tabIndex = landed ? -1 : 0;
            this.dock.setAttribute('aria-hidden', landed ? 'true' : 'false');
          });
          this.io.observe(buy);
        }

        this.setupReviews();
        this.setupShrink();

        this.accItems = Array.from(this.querySelectorAll('.ch-acc__item'));
        this.accItems.forEach((item) => {
          item.removeAttribute('name');
          const summary = item.querySelector('summary');
          summary.addEventListener('click', (event) => {
            event.preventDefault();
            const opening = !item.open || item.hasAttribute('data-closing');
            this.toggleAcc(item, opening);
          });
        });

        this.update(false);
      }

      toggleAcc(item, open) {
        const body = item.querySelector('.ch-acc__body');
        if (!body) return;

        if (open) {
          this.accItems.forEach((other) => {
            if (other !== item && other.open && !other.hasAttribute('data-closing')) this.toggleAcc(other, false);
          });
        }

        const wasOpen = item.open && !item.hasAttribute('data-closing');
        const startHeight = item.open ? body.getBoundingClientRect().height : 0;
        const startOpacity = item.open ? Number(getComputedStyle(body).opacity) : 0;
        if (item.chAnim) item.chAnim.cancel();

        const summary = item.querySelector('summary');
        if (open) {
          item.removeAttribute('data-closing');
          item.open = true;
        } else {
          item.setAttribute('data-closing', '');
        }
        summary.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open === wasOpen && !item.chAnim) return;

        const endHeight = open ? body.scrollHeight : 0;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const frames = reduce
          ? [{ opacity: startOpacity }, { opacity: open ? 1 : 0 }]
          : [
              { height: startHeight + 'px', opacity: startOpacity },
              { height: endHeight + 'px', opacity: open ? 1 : 0 }
            ];

        const anim = body.animate(frames, {
          duration: reduce ? 150 : 220,
          easing: reduce ? 'ease' : 'cubic-bezier(0.23, 1, 0.32, 1)'
        });
        item.chAnim = anim;
        anim.onfinish = () => {
          item.chAnim = null;
          if (!open) {
            item.open = false;
            item.removeAttribute('data-closing');
          }
        };
        anim.oncancel = () => {
          if (item.chAnim === anim) item.chAnim = null;
        };
      }

      setupReviews() {
        const root = this.querySelector('[data-ch-reviews]');
        if (!root) return;
        const slides = Array.from(root.querySelectorAll('[data-ch-rv]'));
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const rv = {
          root,
          slides,
          track: root.querySelector('[data-ch-rv-track]'),
          dots: Array.from(root.querySelectorAll('[data-ch-rv-dot]')),
          index: 0,
          auto: root.dataset.autoplay === 'true' && !reduce && slides.length > 1,
          interval: Number(root.dataset.interval) || 7000,
          stopped: false,
          paused: false,
          visible: false,
          timer: null
        };
        this.rv = rv;

        if ('IntersectionObserver' in window) {
          rv.io = new IntersectionObserver((entries) => {
            rv.visible = entries[0].isIntersecting;
            if (rv.visible) root.classList.add('is-seen');
            this.scheduleReview();
          }, { threshold: 0.6 });
          rv.io.observe(root);
        } else {
          rv.visible = true;
          root.classList.add('is-seen');
        }

        if (slides.length < 2) return;

        rv.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.goReview(Number(dot.dataset.chRvDot), true));
        });

        let startX = 0;
        let startY = 0;
        let tracking = false;
        root.addEventListener('pointerdown', (event) => {
          if (event.target.closest('[data-ch-rv-dot]')) return;
          tracking = true;
          startX = event.clientX;
          startY = event.clientY;
        });
        root.addEventListener('pointerup', (event) => {
          if (!tracking) return;
          tracking = false;
          const dx = event.clientX - startX;
          const dy = event.clientY - startY;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
            this.goReview(rv.index + (dx < 0 ? 1 : -1), true);
          }
        });
        root.addEventListener('pointercancel', () => {
          tracking = false;
        });

        root.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight') this.goReview(rv.index + 1, true);
          if (event.key === 'ArrowLeft') this.goReview(rv.index - 1, true);
        });

        if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          root.addEventListener('mouseenter', () => {
            rv.paused = true;
            this.scheduleReview();
          });
          root.addEventListener('mouseleave', () => {
            rv.paused = false;
            this.scheduleReview();
          });
        }
        root.addEventListener('focusin', () => {
          rv.paused = true;
          this.scheduleReview();
        });
        root.addEventListener('focusout', () => {
          rv.paused = false;
          this.scheduleReview();
        });

        rv.onVisibility = () => this.scheduleReview();
        document.addEventListener('visibilitychange', rv.onVisibility);
      }

      scheduleReview() {
        const rv = this.rv;
        if (!rv) return;
        clearTimeout(rv.timer);
        if (!rv.auto || rv.stopped || rv.paused || !rv.visible || document.hidden) return;
        rv.timer = setTimeout(() => this.goReview(rv.index + 1, false), rv.interval);
      }

      goReview(target, byUser) {
        const rv = this.rv;
        const count = rv.slides.length;
        const next = ((target % count) + count) % count;
        if (next === rv.index) return;

        let dir = 1;
        if (byUser) dir = target < rv.index ? -1 : 1;
        rv.root.style.setProperty('--ch-rv-dir', dir);

        const prev = rv.slides[rv.index];
        const cur = rv.slides[next];

        prev.classList.remove('is-on');
        prev.classList.add('is-out');
        prev.setAttribute('aria-hidden', 'true');
        prev.inert = true;
        clearTimeout(prev.chOutTimer);
        prev.chOutTimer = setTimeout(() => prev.classList.remove('is-out'), 300);

        clearTimeout(cur.chOutTimer);
        cur.classList.remove('is-out');
        void cur.offsetWidth;
        cur.classList.add('is-on');
        cur.removeAttribute('aria-hidden');
        cur.inert = false;

        rv.dots.forEach((dot, i) => {
          dot.classList.toggle('is-on', i === next);
          if (i === next) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });

        rv.track.setAttribute('aria-live', byUser ? 'polite' : 'off');
        rv.index = next;

        if (byUser) {
          rv.stopped = true;
          clearTimeout(rv.timer);
        } else {
          this.scheduleReview();
        }
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        if (this.sk) {
          window.removeEventListener('scroll', this.sk.onScroll);
          window.removeEventListener('resize', this.sk.onScroll);
          if (this.sk.onResize) window.removeEventListener('resize', this.sk.onResize);
          if (this.sk.mq.removeEventListener) this.sk.mq.removeEventListener('change', this.sk.onScroll);
          if (this.sk.io) this.sk.io.disconnect();
          cancelAnimationFrame(this.sk.raf);
        }
        if (this.rv) {
          clearTimeout(this.rv.timer);
          if (this.rv.io) this.rv.io.disconnect();
          document.removeEventListener('visibilitychange', this.rv.onVisibility);
        }
        clearTimeout(this.addedTimer);
        if (this.form) this.form.removeEventListener('submit', this.onSubmit);
      }

      // Mobile only: shrink the photo area as the page scrolls, down to a minimum,
      // then keep it pinned while the content slides behind it.
      setupShrink() {
        const stage = this.querySelector('.ch-stage');
        const wrap = this.querySelector('.ch-wrap');
        if (!stage || !wrap || this.dataset.shrink === 'false') return;
        const mq = window.matchMedia('(max-width: 860px)');
        const rm = window.matchMedia('(prefers-reduced-motion: reduce)');
        const sk = (this.sk = { mq, raf: 0, active: true, last: -1 });

        // Preferred: scroll-driven animation (no per-frame script). Measure once, let CSS do the rest.
        const sd = window.CSS && CSS.supports && CSS.supports('animation-timeline: scroll()');
        if (sd) {
          const measure = () => {
            if (!mq.matches) { this.classList.remove('is-sd'); return; }
            // measure the photo area unanimated
            this.classList.remove('is-sd');
            const cs = getComputedStyle(stage);
            const maxH = stage.offsetHeight;
            const pad = parseFloat(cs.paddingTop) || 0;
            const minH = Math.min(maxH, (Number(this.dataset.shrinkMin) || 240) + pad);
            const top = parseFloat(cs.top) || 0;
            const start = Math.max(0, window.scrollY + wrap.getBoundingClientRect().top - top);
            const cut = Math.max(0, maxH - minH);
            const k = rm.matches ? 1 : (minH - pad) / Math.max(1, maxH - pad);
            this.style.setProperty('--sd-a', start + 'px');
            this.style.setProperty('--sd-b', start + Math.max(1, cut) + 'px');
            this.style.setProperty('--sd-cut', cut + 'px');
            this.style.setProperty('--sd-k', k.toFixed(4));
            this.classList.add('is-sd');
          };
          sk.onScroll = () => {};
          sk.onResize = () => { cancelAnimationFrame(sk.raf); sk.raf = requestAnimationFrame(measure); };
          window.addEventListener('resize', sk.onResize);
          window.addEventListener('load', sk.onResize, { once: true });
          if (mq.addEventListener) mq.addEventListener('change', sk.onResize);
          if (rm.addEventListener) rm.addEventListener('change', sk.onResize);
          measure();
          return;
        }

        const reset = () => {
          stage.style.removeProperty('--ch-cut');
          stage.style.removeProperty('--ch-k');
          stage.style.removeProperty('--ch-dy');
          sk.last = -1;
        };
        const update = () => {
          sk.raf = 0;
          if (!mq.matches) { reset(); return; }
          const maxH = stage.offsetHeight;
          // padding-top is set when a see-through header floats over the photo area
          const pad = parseFloat(getComputedStyle(stage).paddingTop) || 0;
          const minH = Math.min(maxH, (Number(this.dataset.shrinkMin) || 240) + pad);
          const top = parseFloat(getComputedStyle(stage).top) || 0;
          const scrolled = Math.max(0, top - wrap.getBoundingClientRect().top);
          const visible = Math.round(Math.max(minH, maxH - scrolled));
          if (visible === sk.last) return;
          sk.last = visible;
          // scale the photo with the area (or only re-centre it for reduced motion)
          const k = rm.matches ? 1 : (visible - pad) / Math.max(1, maxH - pad);
          stage.style.setProperty('--ch-cut', maxH - visible + 'px');
          stage.style.setProperty('--ch-k', k.toFixed(4));
          stage.style.setProperty('--ch-dy', ((visible - maxH) / 2).toFixed(1) + 'px');
        };
        sk.onScroll = () => {
          if (sk.active && !sk.raf) sk.raf = requestAnimationFrame(update);
        };
        window.addEventListener('scroll', sk.onScroll, { passive: true });
        window.addEventListener('resize', sk.onScroll);
        if (mq.addEventListener) mq.addEventListener('change', sk.onScroll);
        // only do work while the section is on screen
        if ('IntersectionObserver' in window) {
          sk.io = new IntersectionObserver((entries) => {
            sk.active = entries[0].isIntersecting;
            if (sk.active) sk.onScroll();
          });
          sk.io.observe(this);
        }
        update();
      }

      norm(value) {
        return String(value || '').trim().toLowerCase();
      }

      setMatches(value, set) {
        const target = this.norm(set === 'complete' ? this.data.complete : this.data.only);
        const v = this.norm(value);
        if (!target) return false;
        return v === target || v.includes(target);
      }

      resolveOptions() {
        const names = this.data.worlds.map((w) => this.norm(w.name));
        const count = this.data.variants.length ? this.data.variants[0].options.length : 0;
        this.worldIdx = -1;
        this.setIdx = -1;
        for (let i = 0; i < count; i++) {
          const values = this.data.variants.map((v) => this.norm(v.options[i]));
          if (this.worldIdx < 0 && values.some((x) => names.includes(x))) {
            this.worldIdx = i;
          } else if (this.setIdx < 0 && values.some((x) => this.setMatches(x, 'complete') || this.setMatches(x, 'only'))) {
            this.setIdx = i;
          }
        }
        this.names = names;
      }

      stateFromVariant(id) {
        const variant = this.data.variants.find((v) => v.id === id) || this.data.variants[0];
        let world = 0;
        let set = 'complete';
        if (variant && this.worldIdx >= 0) {
          const idx = this.names.indexOf(this.norm(variant.options[this.worldIdx]));
          if (idx >= 0) world = idx;
        }
        if (variant && this.setIdx >= 0) {
          set = this.setMatches(variant.options[this.setIdx], 'complete') ? 'complete' : 'only';
        }
        return { world, set, gift: false };
      }

      find(world, set) {
        return this.data.variants.find((v) => {
          const worldOk = this.worldIdx < 0 || this.norm(v.options[this.worldIdx]) === this.names[world];
          const setOk = this.setIdx < 0 || this.setMatches(v.options[this.setIdx], set);
          return worldOk && setOk;
        });
      }

      worldAvailable(world) {
        if (this.worldIdx < 0) return true;
        return this.data.variants.some((v) => v.available && this.norm(v.options[this.worldIdx]) === this.names[world]);
      }

      money(cents) {
        if (window.theme && theme.Currency && theme.Currency.formatMoney) {
          return theme.Currency.formatMoney(cents, (theme.settings && theme.settings.moneyFormat) || this.data.moneyFormat);
        }
        const amount = (cents / 100).toFixed(2);
        return this.data.moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, amount);
      }

      pickWorld(world) {
        if (!this.worldAvailable(world)) return;
        this.state.world = world;
        const other = this.state.set === 'complete' ? 'only' : 'complete';
        const current = this.find(world, this.state.set);
        const alt = this.find(world, other);
        if ((!current || !current.available) && alt && alt.available) this.state.set = other;
        this.update(true);
      }

      pickSet(set) {
        const variant = this.find(this.state.world, set);
        if (!variant || !variant.available) return;
        this.state.set = set;
        this.update(true);
      }

      onGift() {
        this.state.gift = this.giftBox.checked;
        if (this.note) this.note.disabled = !this.state.gift;
        if (this.giftPanel) this.giftPanel.classList.toggle('is-open', this.state.gift);
        this.updateMessage();
      }

      updateMessage() {
        const index = this.state.gift ? 2 : this.state.set === 'complete' ? 0 : 1;
        this.querySelectorAll('[data-ch-msg]').forEach((el) => {
          el.classList.toggle('is-on', Number(el.dataset.chMsg) === index);
        });
      }

      update(pushUrl) {
        const { world, set } = this.state;
        const w = this.data.worlds[world];
        const variant = this.find(world, set);

        this.dataset.stage = w ? w.stage : 'forest';
        this.dataset.set = set;

        this.querySelectorAll('[data-ch-bg]').forEach((el) => {
          el.classList.toggle('is-on', Number(el.dataset.chBg) === world);
        });
        this.querySelectorAll('[data-ch-shot]').forEach((img) => {
          const on = Number(img.dataset.world) === world && (img.dataset.set === 'any' || img.dataset.set === set);
          if (on && img.loading === 'lazy') img.loading = 'eager';
          img.classList.toggle('is-on', on);
        });
        this.querySelectorAll('[data-ch-world]').forEach((btn) => {
          const i = Number(btn.dataset.chWorld);
          const available = this.worldAvailable(i);
          btn.classList.toggle('is-on', i === world);
          btn.setAttribute('aria-pressed', i === world ? 'true' : 'false');
          btn.classList.toggle('is-soldout', !available);
          btn.disabled = !available;
        });
        this.querySelectorAll('[data-ch-line]').forEach((el) => {
          el.classList.toggle('is-on', Number(el.dataset.chLine) === world);
        });
        this.querySelectorAll('[data-ch-set]').forEach((btn) => {
          const s = btn.dataset.chSet;
          const v = this.find(world, s);
          const ok = !!(v && v.available);
          btn.classList.toggle('is-on', s === set);
          btn.setAttribute('aria-pressed', s === set ? 'true' : 'false');
          btn.classList.toggle('is-soldout', !ok);
          if (ok) btn.removeAttribute('aria-disabled');
          else btn.setAttribute('aria-disabled', 'true');
          const amt = btn.querySelector('[data-ch-amt]');
          if (amt) amt.textContent = ok ? this.money(v.price) : this.data.strings.soldOut;
        });

        if (w) {
          const lampThumb = this.querySelector('[data-ch-thumb="complete"]');
          if (lampThumb && w.lamp) {
            lampThumb.removeAttribute('srcset');
            lampThumb.src = w.lamp;
          }
          const tileThumb = this.querySelector('[data-ch-thumb="only"]');
          if (tileThumb && w.tile) {
            tileThumb.removeAttribute('srcset');
            tileThumb.src = w.tile;
          }
        }

        this.updateMessage();

        if (!variant) return;
        this.idInput.value = variant.id;

        const price = this.querySelector('[data-ch-price]');
        if (price) price.textContent = this.money(variant.price);
        const compare = this.querySelector('[data-ch-compare]');
        if (compare) {
          const onSale = variant.compare > variant.price;
          compare.hidden = !onSale;
          if (onSale) compare.textContent = this.money(variant.compare);
        }
        const perDay = this.querySelector('[data-ch-perday]');
        if (perDay) perDay.textContent = this.data.strings.perDay.replace('[price]', this.money(Math.round(variant.price / 365)));

        const ctaLabel = this.querySelector('[data-ch-cta-label]');
        const dockLabel = this.querySelector('[data-ch-dock-label]');
        this.cta.disabled = !variant.available;
        this.dock.disabled = !variant.available;
        if (ctaLabel) ctaLabel.textContent = variant.available ? this.data.strings.addToCart : this.data.strings.soldOut;
        if (dockLabel) {
          dockLabel.textContent = variant.available
            ? this.data.strings.addShort.replace('[price]', this.money(variant.price))
            : this.data.strings.soldOut;
        }

        if (pushUrl && !(window.Shopify && Shopify.designMode)) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      showAdded() {
        [this.cta, this.dock].forEach((btn) => btn.classList.add('is-added'));
        const w = this.data.worlds[this.state.world];
        this.statusEl.textContent = this.data.strings.added.replace('[title]', w ? w.name : this.data.productTitle);
        clearTimeout(this.addedTimer);
        this.addedTimer = setTimeout(() => {
          [this.cta, this.dock].forEach((btn) => btn.classList.remove('is-added'));
          this.statusEl.textContent = '';
        }, 1800);
      }

      setBusy(busy) {
        [this.cta, this.dock].forEach((btn) => {
          if (busy) btn.setAttribute('aria-busy', 'true');
          else btn.removeAttribute('aria-busy');
        });
      }

      async onSubmit(event) {
        const cartIsPage = window.theme && theme.settings && theme.settings.cartType === 'page';
        if (cartIsPage) return;
        event.preventDefault();
        if (this.busy || this.cta.disabled) return;

        this.busy = true;
        this.setBusy(true);
        this.errorEl.hidden = true;

        const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        const sections = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections } })
        );

        const formData = new FormData(this.form);
        if (sections.length) {
          formData.append('sections', sections);
          formData.append('sections_url', window.location.pathname);
        }

        try {
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: formData
          });
          const parsed = await response.json();

          if (!response.ok || parsed.status) {
            this.errorEl.textContent = parsed.description || parsed.message || this.data.strings.error;
            this.errorEl.hidden = false;
            return;
          }

          const cart = await (await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })).json();
          cart.sections = parsed.sections;

          if (window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) {
            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cart
            });
          }
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: parsed } }));

          this.showAdded();

          const drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.show === 'function') {
            drawer.show(event.submitter || this.cta);
          } else {
            window.location.href = `${root}cart`;
          }
        } catch (error) {
          this.errorEl.textContent = this.data.strings.error;
          this.errorEl.hidden = false;
        } finally {
          this.busy = false;
          this.setBusy(false);
        }
      }
    }

    customElements.define('calmyr-hero', CalmyrHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calmyr-home-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('calmyr-home-hero')) return;

  class CalmyrHomeHero extends HTMLElement {
    connectedCallback() {
      this.card = this.querySelector('.chh__card');
      this.video = this.querySelector('.chh__video');
      if (!this.video) return;
      const v = this.video;
      v.muted = true;
      v.removeAttribute('controls');
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onPlaying = () => this.card.classList.add('is-playing');
      v.addEventListener('playing', this.onPlaying);

      // play only while on screen, never for people who asked for less motion
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver((entries) => {
          if (entries[0].isIntersecting) this.play();
          else v.pause();
        }, { threshold: 0.2 });
        this.io.observe(this.card);
      } else {
        this.play();
      }
      this.onVis = () => (document.hidden ? v.pause() : this.inView() && this.play());
      document.addEventListener('visibilitychange', this.onVis);
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.video) this.video.removeEventListener('playing', this.onPlaying);
      if (this.onVis) document.removeEventListener('visibilitychange', this.onVis);
    }

    inView() {
      const r = this.card.getBoundingClientRect();
      return r.bottom > 0 && r.top < window.innerHeight;
    }

    play() {
      if (this.reduce.matches) return;
      const v = this.video;
      if (v.preload === 'none') v.preload = 'auto';
      const p = v.play();
      if (p && p.catch) p.catch(() => {});
    }
  }
  customElements.define('calmyr-home-hero', CalmyrHomeHero);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calmyr-home-worlds"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (customElements.get('calmyr-worlds')) return;
  class CalmyrWorlds extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var self = this;
      this.viewport = this.querySelector('.cw__viewport');
      this.cards = Array.prototype.slice.call(this.querySelectorAll('.cw__card'));
      this.dots = Array.prototype.slice.call(this.querySelectorAll('.cw__dot'));
      this.arrows = Array.prototype.slice.call(this.querySelectorAll('.cw__arrow'));
      this.live = this.querySelector('.cw__sr');
      this.n = this.cards.length;
      if (!this.n) return;
      this.reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.active = Math.min(this.n - 1, Math.max(0, parseInt(this.dataset.start, 10) || 0));
      this.render(false);

      /* one-time fan-out on first view */
      if (!this.reduce && 'IntersectionObserver' in window && this.n > 1) {
        this.classList.add('is-pre');
        this.io = new IntersectionObserver(function (entries) {
          if (!entries.some(function (e) { return e.isIntersecting; })) return;
          self.io.disconnect();
          self.classList.add('is-fanning');
          requestAnimationFrame(function () {
            self.classList.remove('is-pre');
            setTimeout(function () { self.classList.remove('is-fanning'); }, 700);
          });
        }, { threshold: 0.35 });
        this.io.observe(this.viewport);
      }

      this.arrows.forEach(function (a) {
        a.addEventListener('click', function () { self.go(self.active + parseInt(a.getAttribute('data-dir'), 10)); });
      });
      this.dots.forEach(function (d) {
        d.addEventListener('click', function () { self.go(parseInt(d.getAttribute('data-go'), 10)); });
      });
      this.cards.forEach(function (c, i) {
        c.addEventListener('click', function (e) {
          if (self.dragMoved) { e.preventDefault(); e.stopPropagation(); return; }
          if (i !== self.active) { e.preventDefault(); self.go(i); }
        }, true);
      });
      this.querySelectorAll('button.cw__cta').forEach(function (btn) {
        btn.addEventListener('click', function () { self.choose(btn.getAttribute('data-world')); });
      });
      this.viewport.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); self.go(self.active + 1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); self.go(self.active - 1); }
      });

      /* drag / swipe: cards follow the pointer, then settle */
      this.onDown = function (e) {
        if (e.button !== undefined && e.button !== 0) return;
        self.drag = { x: e.clientX, y: e.clientY, t: performance.now(), dx: 0, lock: null, id: e.pointerId };
        self.dragMoved = false;
      };
      this.onMove = function (e) {
        var d = self.drag;
        if (!d || e.pointerId !== d.id) return;
        var dx = e.clientX - d.x, dy = e.clientY - d.y;
        if (d.lock === null) {
          if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
          d.lock = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
          if (d.lock === 'x') {
            self.classList.add('is-dragging');
            try { self.viewport.setPointerCapture(d.id); } catch (err) {}
          }
        }
        if (d.lock !== 'x') return;
        self.dragMoved = true;
        /* resist past the first / last card */
        var atEdge = (self.active === 0 && dx > 0) || (self.active === self.n - 1 && dx < 0);
        d.dx = atEdge ? dx * 0.35 : dx;
        d.v = dx / Math.max(1, performance.now() - d.t);
        self.render(false, d.dx / self.step());
      };
      this.onUp = function (e) {
        var d = self.drag;
        if (!d || e.pointerId !== d.id) return;
        self.drag = null;
        self.classList.remove('is-dragging');
        if (d.lock !== 'x') return;
        var step = self.step(), move = 0;
        if (Math.abs(d.dx) > step * 0.22 || Math.abs(d.v || 0) > 0.45) move = d.dx < 0 ? 1 : -1;
        self.go(self.active + move, true);
        setTimeout(function () { self.dragMoved = false; }, 0);
      };
      this.viewport.addEventListener('pointerdown', this.onDown);
      this.viewport.addEventListener('pointermove', this.onMove);
      this.viewport.addEventListener('pointerup', this.onUp);
      this.viewport.addEventListener('pointercancel', this.onUp);
    }
    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      this._ready = false;
    }
    step() {
      if (window.matchMedia('(min-width: 861px)').matches) return 372;
      return this.cards[this.active].offsetWidth + 14;
    }
    render(announce, offset) {
      var self = this;
      offset = offset || 0;
      this.cards.forEach(function (c, i) {
        var pos = i - self.active;
        c.setAttribute('data-pos', String(pos));
        c.style.setProperty('--pos', (pos + offset).toFixed(4));
        c.classList.toggle('is-far', Math.abs(pos) > 1 && Math.abs(pos + offset) > 1.2);
        c.setAttribute('aria-hidden', pos === 0 ? 'false' : 'true');
        var cta = c.querySelector('.cw__cta');
        if (cta) cta.tabIndex = pos === 0 ? 0 : -1;
      });
      this.dots.forEach(function (d, i) {
        d.classList.toggle('is-on', i === self.active);
        if (i === self.active) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
      if (this.arrows.length === 2) {
        this.arrows[0].disabled = this.active === 0;
        this.arrows[1].disabled = this.active === this.n - 1;
      }
      if (announce && this.live) {
        var name = this.cards[this.active].querySelector('.cw__name');
        this.live.textContent = (name ? name.textContent : '') + ', ' + (this.active + 1) + ' / ' + this.n;
      }
    }
    go(i) {
      var next = Math.max(0, Math.min(this.n - 1, i));
      this.active = next;
      this.render(true);
    }
    /* select the world in the Calmyr hero buy box, then scroll up to it */
    choose(name) {
      var key = (name || '').trim().toLowerCase();
      var hero = document.querySelector('calmyr-hero');
      var btns = document.querySelectorAll('calmyr-hero .ch-world, .ch-world');
      var target = null;
      for (var i = 0; i < btns.length; i++) {
        if (btns[i].textContent.trim().toLowerCase().indexOf(key) !== -1) { target = btns[i]; break; }
      }
      if (target && !target.disabled && !target.classList.contains('is-on')) target.click();
      var dest = hero || document.querySelector('product-form, form[action*="/cart/add"]');
      if (!dest) return;
      var head = 0;
      var hs = document.querySelectorAll('.shopify-section-group-header-group, sticky-header, .header-wrapper');
      for (var j = 0; j < hs.length; j++) {
        var cs = getComputedStyle(hs[j]);
        if (cs.position === 'sticky' || cs.position === 'fixed') head = Math.max(head, hs[j].getBoundingClientRect().bottom);
      }
      var y = window.scrollY + dest.getBoundingClientRect().top - head - 12;
      window.scrollTo({ top: Math.max(0, y), behavior: this.reduce ? 'auto' : 'smooth' });
    }
  }
  customElements.define('calmyr-worlds', CalmyrWorlds);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calmyr-plant-stack"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (customElements.get('calmyr-stack')) return;
  class CalmyrStack extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var self = this;
      this.stage = this.querySelector('.cs3__stage');
      this.video = this.querySelector('video.cs3__media');
      this.cards = Array.prototype.slice.call(this.querySelectorAll('.cs3__card'));
      this.anchors = Array.prototype.slice.call(this.querySelectorAll('.cs3__anchor'));
      this.bars = Array.prototype.slice.call(this.querySelectorAll('.cs3__bar i'));
      this.navs = Array.prototype.slice.call(this.querySelectorAll('.cs3__navbtn'));
      this.reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.on = -1;

      this.onScroll = function () {
        if (self.raf) return;
        self.raf = requestAnimationFrame(function () { self.raf = 0; self.update(); });
      };
      this.onResize = function () { self.layout(); self.update(); };

      this.navs.forEach(function (btn) {
        btn.addEventListener('click', function () { self.go(parseInt(btn.getAttribute('data-go'), 10)); });
      });

      if (this.video) {
        this.video.muted = true;
        this.video.setAttribute('playsinline', '');
        this.video.removeAttribute('autoplay');
      }

      this.io = new IntersectionObserver(function (entries) {
        var visible = entries.some(function (e) { return e.isIntersecting; });
        if (visible && !self.listening) {
          window.addEventListener('scroll', self.onScroll, { passive: true });
          self.listening = true;
          self.update();
        } else if (!visible && self.listening) {
          window.removeEventListener('scroll', self.onScroll);
          self.listening = false;
        }
        self.playback(visible);
      }, { rootMargin: '200px 0px 200px 0px' });
      this.io.observe(this);

      window.addEventListener('resize', this.onResize, { passive: true });
      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(this.onResize);
        this.ro.observe(this.stage);
      }
      this.layout();
      this.update();
    }
    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.ro) this.ro.disconnect();
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      if (this.raf) cancelAnimationFrame(this.raf);
      this._ready = false;
      this.listening = false;
    }
    /* Sticky header height so the pinned video sits below it */
    headerHeight() {
      var h = 0;
      var els = document.querySelectorAll('.shopify-section-group-header-group, sticky-header, .header-wrapper, header.header');
      for (var i = 0; i < els.length; i++) {
        var cs = getComputedStyle(els[i]);
        if (cs.position !== 'sticky' && cs.position !== 'fixed') continue;
        var r = els[i].getBoundingClientRect();
        if (r.height > 0 && r.height < 240 && r.top <= 1) h = Math.max(h, r.bottom);
      }
      return h;
    }
    layout() {
      var desktop = window.matchMedia('(min-width: 861px)').matches;
      var base = desktop ? 40 : 12;
      var extra = parseInt(this.dataset.extra, 10) || 0;
      this.style.setProperty('--cs3-top', (this.headerHeight() + base + extra) + 'px');
      this.style.setProperty('--cs3-stage-h', this.stage.getBoundingClientRect().height + 'px');
      /* equal bottom edges when stacked: card i is `step` shorter than card i-1 */
      var step = desktop ? 14 : 12, need = 0;
      this.cards.forEach(function (c) { c.style.minHeight = '0px'; });
      this.cards.forEach(function (c, i) { need = Math.max(need, c.offsetHeight + i * step); });
      this.cards.forEach(function (c) { c.style.minHeight = ''; });
      this.style.setProperty('--cs3-card-h', need + 'px');
      this.step = step;
    }
    stuckTop(card) { return parseFloat(getComputedStyle(card).top) || 0; }
    update() {
      var n = this.cards.length;
      if (!n) return;
      var tops = [], stuck = [], f = [], on = 0, k;
      for (k = 0; k < n; k++) {
        tops.push(this.cards[k].getBoundingClientRect().top);
        stuck.push(this.stuckTop(this.cards[k]));
      }
      for (k = 0; k < n; k++) {
        /* starts when card k touches the bottom of card k-1, done when it is stuck */
        var ramp = k > 0 ? Math.max(60, this.cards[k - 1].offsetHeight - this.step) : 1;
        f.push(k === 0 ? 0 : Math.max(0, Math.min(1, 1 - (tops[k] - stuck[k]) / ramp)));
        if (tops[k] <= stuck[k] + 1.5) on = k;
      }
      if (!this.reduce) {
        for (var i = 0; i < n; i++) {
          var sum = 0;
          for (k = i + 1; k < n; k++) sum += f[k];
          this.cards[i].style.transform = sum ? 'scale(' + (1 - 0.045 * sum).toFixed(4) + ')' : '';
          this.cards[i].style.filter = sum ? 'brightness(' + (1 - 0.035 * sum).toFixed(4) + ')' : '';
        }
      }
      if (on !== this.on) {
        this.on = on;
        var stuckCount = 0;
        for (k = 0; k < n; k++) if (tops[k] <= stuck[k] + 1.5) stuckCount = k + 1;
        this.bars.forEach(function (b, j) { b.classList.toggle('is-on', j < Math.max(1, stuckCount)); });
        this.navs.forEach(function (b, j) {
          b.classList.toggle('is-on', j === on);
          if (j === on) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
        });
      }
    }
    go(i) {
      var a = this.anchors[i], c = this.cards[i];
      if (!a || !c) return;
      var y = window.scrollY + a.getBoundingClientRect().top - this.stuckTop(c) + 2;
      window.scrollTo({ top: y, behavior: this.reduce ? 'auto' : 'smooth' });
    }
    playback(visible) {
      var v = this.video;
      if (!v) return;
      if (this.reduce) { v.pause(); return; }
      if (visible) {
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      } else {
        v.pause();
      }
    }
  }
  customElements.define('calmyr-stack', CalmyrStack);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calmyr-promise"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('calmyr-promise')) return;
  class CalmyrPromise extends HTMLElement {
    connectedCallback() {
      if (!('IntersectionObserver' in window)) return;
      this.classList.add('js');
      this.io = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          this.classList.add('is-in');
          this.io.disconnect();
        }
      }, { rootMargin: '0px 0px -15% 0px' });
      this.io.observe(this);
    }
    disconnectedCallback() {
      if (this.io) this.io.disconnect();
    }
  }
  customElements.define('calmyr-promise', CalmyrPromise);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calmyr-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('calmyr-reviews')) return;
  const reduce = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class CalmyrReviews extends HTMLElement {
    connectedCallback() {
      this.wall = this.querySelector('[data-wall]');
      if (!this.wall) return;
      this.clip = this.querySelector('[data-clip]');
      this.cards = [...this.wall.querySelectorAll('[data-card]')];
      this.more = this.querySelector('[data-more]');
      this.none = this.querySelector('[data-none]');
      this.lb = this.querySelector('[data-lb]');
      this.classList.add('js');
      this.index();

      this.querySelectorAll('[data-filter]').forEach((chip) =>
        chip.addEventListener('click', () => this.filter(chip))
      );
      if (this.more) this.more.addEventListener('click', () => this.open());
      this.wall.addEventListener('click', (e) => {
        const z = e.target.closest('[data-zoom]');
        if (z) this.zoom(z);
      });
      if (this.lb) {
        this.lb.addEventListener('click', (e) => {
          if (e.target === this.lb || e.target.closest('[data-lb-close]')) this.lb.close();
        });
      }

      this.ro = new ResizeObserver(() => this.measure());
      this.ro.observe(this.wall);
      this.wall.querySelectorAll('img').forEach((img) => {
        if (!img.complete) img.addEventListener('load', () => this.measure(), { once: true });
      });
      this.measure();

      if (reduce() || !('IntersectionObserver' in window)) {
        this.classList.add('is-in');
      } else {
        this.io = new IntersectionObserver((entries) => {
          if (entries.some((en) => en.isIntersecting)) {
            this.classList.add('is-in');
            this.io.disconnect();
          }
        }, { rootMargin: '0px 0px -12% 0px' });
        this.io.observe(this.wall);
      }
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.ro) this.ro.disconnect();
      clearTimeout(this.swapT);
    }

    // stagger only the cards a visitor can actually see on first view
    index() {
      let n = 0;
      this.cards.forEach((c) => {
        if (!c.hidden) c.style.setProperty('--i', Math.min(n++, 10));
      });
    }

    measure() {
      if (this.classList.contains('is-open')) return;
      const limit = parseFloat(getComputedStyle(this.clip).maxHeight);
      const over = Number.isFinite(limit) && this.wall.offsetHeight > limit + 8;
      this.classList.toggle('is-over', over);
    }

    filter(chip) {
      if (chip.getAttribute('aria-pressed') === 'true') return;
      this.querySelectorAll('[data-filter]').forEach((c) => c.setAttribute('aria-pressed', String(c === chip)));
      const f = chip.dataset.filter;
      const apply = () => {
        let shown = 0;
        this.cards.forEach((c) => {
          const ok = f === 'all' || (f === 'photo' ? c.dataset.photo === 'true' : c.dataset.world === f);
          c.hidden = !ok;
          if (ok) shown++;
        });
        if (this.none) this.none.hidden = shown > 0;
        this.index();
        this.measure();
      };
      clearTimeout(this.swapT);
      if (reduce()) { apply(); return; }
      this.wall.classList.add('is-out');
      this.swapT = setTimeout(() => {
        apply();
        requestAnimationFrame(() => this.wall.classList.remove('is-out'));
      }, 170);
    }

    open() {
      const c = this.clip;
      const from = c.getBoundingClientRect().height;
      const to = this.wall.offsetHeight;
      this.more.setAttribute('aria-expanded', 'true');
      if (reduce()) { this.classList.add('is-open'); return; }
      c.style.maxHeight = from + 'px';
      c.offsetHeight; // commit the start height
      c.style.maxHeight = to + 'px';
      const done = () => {
        this.classList.add('is-open');
        c.style.maxHeight = '';
      };
      c.addEventListener('transitionend', function te(e) {
        if (e.propertyName !== 'max-height') return;
        this.removeEventListener('transitionend', te);
        done();
      });
      setTimeout(() => { if (!this.classList.contains('is-open')) done(); }, 900);
      const fade = this.querySelector('.crv__fade');
      if (fade) fade.style.opacity = '0';
    }

    zoom(btn) {
      const img = btn.querySelector('img');
      if (!img || !this.lb || typeof this.lb.showModal !== 'function') return;
      const big = this.lb.querySelector('[data-lb-img]');
      big.src = btn.dataset.big || img.currentSrc || img.src;
      big.alt = img.alt || '';
      this.lb.showModal();
    }
  }
  customElements.define('calmyr-reviews', CalmyrReviews);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calmyr-screen-time"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (customElements.get('calmyr-screen')) return;
  class CalmyrScreen extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.timers = [];
      this.step = -1;
      this.rows = Array.prototype.slice.call(this.querySelectorAll('.cs2__row'));
      this.calm = this.querySelector('.cs2__note--calm');
      this.stage = this.querySelector('.cs2__stage');
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !this.stage || !this.calm || !('IntersectionObserver' in window)) return;
      this.classList.add('cs2--anim');
      this.clear = this.dataset.end === 'clear' && this.rows.length > 0;
      this.last = this.rows.length + 1 + (this.clear ? 1 : 0);
      this.set(0);
      var self = this;
      if (this.dataset.trigger === 'once') {
        this.io = new IntersectionObserver(function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) { self.io.disconnect(); self.play(); break; }
          }
        }, { threshold: 0.4 });
      } else {
        this.onScroll = function () {
          if (self.raf) return;
          self.raf = requestAnimationFrame(function () { self.raf = 0; self.update(); });
        };
        this.io = new IntersectionObserver(function (entries) {
          var on = entries[entries.length - 1].isIntersecting;
          if (on && !self.listening) {
            window.addEventListener('scroll', self.onScroll, { passive: true });
            window.addEventListener('resize', self.onScroll, { passive: true });
            self.listening = true;
          } else if (!on && self.listening) {
            window.removeEventListener('scroll', self.onScroll);
            window.removeEventListener('resize', self.onScroll);
            self.listening = false;
          }
          self.update();
        }, { rootMargin: '25% 0px 25% 0px' });
      }
      this.io.observe(this.stage);
    }
    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.onScroll) {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }
      if (this.raf) cancelAnimationFrame(this.raf);
      (this.timers || []).forEach(clearTimeout);
      this._ready = false;
      this.listening = false;
    }
    /* Scroll mode: progress 0 -> 1 while the photo's top travels from 85% of the
       viewport up by "span" % of the viewport. Steps are spread over that range,
       so scrolling back up plays them in reverse. */
    update() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var top = this.stage.getBoundingClientRect().top;
      var span = (parseInt(this.dataset.span, 10) || 60) / 100 * vh;
      var p = (vh * 0.85 - top) / span;
      var arrive = this.rows.length + 1;
      var step;
      if (p <= 0) step = 0;
      else if (p >= 0.9 && this.clear) step = this.last;
      else step = Math.min(arrive, Math.floor(p / 0.7 * arrive) + 1);
      if (step !== this.step) this.set(step);
    }
    play() {
      var self = this;
      var n = this.rows.length;
      var gap = parseInt(this.dataset.gap, 10) || 450;
      for (var i = 1; i <= n + 1; i++) {
        (function (step) {
          self.timers.push(setTimeout(function () { self.set(step); }, 250 + (step - 1) * gap));
        })(i);
      }
      if (this.clear) {
        this.timers.push(setTimeout(function () { self.set(n + 2); }, 250 + n * gap + 1800));
      }
    }
    set(step) {
      var n = this.rows.length;
      var latest = Math.min(step, n + 1) - 1;
      var cleared = step > n + 1;
      this.rows.forEach(function (row, i) {
        var note = row.querySelector('.cs2__note');
        if (cleared) {
          note.style.transitionDelay = (i * 60) + 'ms';
          note.setAttribute('data-st', 'gone');
          row.setAttribute('data-gone', '');
          return;
        }
        var wasGone = row.hasAttribute('data-gone');
        row.removeAttribute('data-gone');
        /* coming back: let the row open first, then fade the note in */
        note.style.transitionDelay = wasGone ? (200 + (n - 1 - i) * 60) + 'ms' : '';
        if (step <= i) { note.removeAttribute('data-st'); return; }
        var depth = latest - i;
        note.setAttribute('data-st', depth <= 1 ? 'd0' : depth === 2 ? 'd2' : 'd3');
      });
      if (step > n) this.calm.setAttribute('data-st', 'd0');
      else this.calm.removeAttribute('data-st');
      this.step = step;
    }
  }
  customElements.define('calmyr-screen', CalmyrScreen);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calmyr-wipe-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.name && window.name.indexOf('cwp-frame') === 0) return;

    const KEY_STATE = 'cwp_state';
    const KEY_PRIZE = 'cwp_prize';
    const KEY_PENDING = 'cwp_pending';
    const TAU = Math.PI * 2;

    const store = {
      get(key) {
        try { return JSON.parse(localStorage.getItem(key)); } catch (e) { return null; }
      },
      set(key, value) {
        try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) {}
      },
      remove(key) {
        try { localStorage.removeItem(key); } catch (e) {}
      }
    };

    const fill = (template, amount) => (template || '').split('[amount]').join(String(amount));
    const rand = (min, max) => min + Math.random() * (max - min);
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const drawBead = (ctx, x, y, r, o) => {
      ctx.save();
      ctx.globalCompositeOperation = 'source-over';
      ctx.globalAlpha = 1;
      ctx.fillStyle = `rgba(30, 60, 38, ${0.3 * o})`;
      ctx.beginPath();
      ctx.ellipse(x, y + r * 0.22, r * 1.04, r * 0.98, 0, 0, TAU);
      ctx.fill();
      const body = ctx.createRadialGradient(x - r * 0.3, y - r * 0.35, r * 0.05, x, y, r);
      body.addColorStop(0, `rgba(255, 255, 255, ${0.95 * o})`);
      body.addColorStop(0.5, `rgba(228, 238, 224, ${0.5 * o})`);
      body.addColorStop(1, `rgba(255, 255, 255, ${0.22 * o})`);
      ctx.fillStyle = body;
      ctx.beginPath();
      ctx.arc(x, y, r, 0, TAU);
      ctx.fill();
      ctx.fillStyle = `rgba(255, 255, 255, ${o})`;
      ctx.beginPath();
      ctx.arc(x - r * 0.36, y - r * 0.38, Math.max(r * 0.26, 0.6), 0, TAU);
      ctx.fill();
      ctx.strokeStyle = `rgba(255, 255, 255, ${0.5 * o})`;
      ctx.lineWidth = Math.max(r * 0.14, 0.5);
      ctx.beginPath();
      ctx.arc(x, y, r * 0.72, Math.PI * 0.2, Math.PI * 0.8);
      ctx.stroke();
      ctx.restore();
    };

    class WipePopup {
      constructor(root) {
        this.root = root;
        this.sheet = root.querySelector('.cwp__sheet');
        this.canvas = root.querySelector('[data-cwp-canvas]');
        this.ctx = this.canvas.getContext('2d', { willReadFrequently: true });
        this.dropsCanvas = root.querySelector('[data-cwp-drops]');
        this.dctx = this.dropsCanvas.getContext('2d');
        this.form = root.querySelector('form');
        this.frame = root.querySelector('[data-cwp-frame]');
        this.email = this.form.querySelector('input[type="email"]');
        this.tags = root.querySelector('[data-cwp-tags]');
        this.submit = root.querySelector('[data-cwp-submit]');
        this.error = root.querySelector('[data-cwp-error]');
        this.live = root.querySelector('[data-cwp-live]');
        this.isDesign = root.dataset.design === 'true';
        this.isTest = root.dataset.test === 'true';
        this.revealed = false;
        this.posting = false;
        this.drips = [];
        this.form.target = this.frame.name;
        this.prize = this.pickPrize();
        root.querySelector('[data-cwp-pct]').textContent = this.prize.label;
        this.bind();
        this.boot();
      }

      pickPrize() {
        let prizes = [];
        try { prizes = JSON.parse(this.root.querySelector('[data-cwp-prizes]').textContent); } catch (e) {}
        prizes = prizes.filter((p) => p.code && Number(p.amount) > 0 && Number(p.weight) > 0);
        if (!prizes.length) return { code: '', amount: 0, label: '' };
        const saved = store.get(KEY_PRIZE);
        if (saved && prizes.some((p) => p.code === saved.code)) return prizes.find((p) => p.code === saved.code);
        const total = prizes.reduce((sum, p) => sum + Number(p.weight), 0);
        let roll = Math.random() * total;
        let chosen = prizes[prizes.length - 1];
        for (const p of prizes) {
          roll -= Number(p.weight);
          if (roll < 0) { chosen = p; break; }
        }
        store.set(KEY_PRIZE, { code: chosen.code });
        return chosen;
      }

      boot() {
        if (!this.prize.code) return;
        if (this.isDesign) {
          document.addEventListener('shopify:section:select', (e) => {
            if (this.root.id.endsWith(e.detail.sectionId)) this.open();
          });
          document.addEventListener('shopify:section:deselect', (e) => {
            if (this.root.id.endsWith(e.detail.sectionId)) this.close(false);
          });
          return;
        }
        const params = new URLSearchParams(location.search);
        if (params.get('customer_posted') === 'true' && store.get(KEY_PENDING)) {
          store.remove(KEY_PENDING);
          params.delete('customer_posted');
          const query = params.toString();
          history.replaceState(null, '', location.pathname + (query ? `?${query}` : ''));
          this.open();
          this.showWon();
          return;
        }
        if (!this.isTest) {
          const state = store.get(KEY_STATE);
          if (state && state.status === 'claimed') return;
          if (state && state.status === 'dismissed') {
            const days = Number(this.root.dataset.days) || 14;
            if (Date.now() - state.at < days * 864e5) return;
          }
        }
        const delay = (Number(this.root.dataset.delay) || 0) * 1000;
        window.setTimeout(() => this.open(), delay);
      }

      bind() {
        this.root.querySelectorAll('[data-cwp-close]').forEach((el) => {
          el.addEventListener('click', () => this.close(true));
        });
        this.root.addEventListener('keydown', (e) => this.onKey(e));
        this.root.querySelector('[data-cwp-reveal]').addEventListener('click', () => this.reveal(true));
        this.form.addEventListener('submit', (e) => this.onSubmit(e));
        this.frame.addEventListener('load', () => this.onFrameLoad());
        this.root.querySelector('[data-cwp-copy]').addEventListener('click', (e) => this.copy(e.currentTarget));

        this.canvas.addEventListener('pointerdown', (e) => {
          if (this.revealed) return;
          e.preventDefault();
          this.drawing = true;
          this.last = this.point(e);
          this.edgeTravel = 0;
          this.dripTravel = 0;
          this.moves = 0;
          this.canvas.setPointerCapture(e.pointerId);
          if (navigator.vibrate) navigator.vibrate(5);
          this.wipe(this.last, this.last);
        });
        this.canvas.addEventListener('pointermove', (e) => {
          if (!this.drawing || this.revealed) return;
          const p = this.point(e);
          const dist = Math.hypot(p.x - this.last.x, p.y - this.last.y);
          if (dist < 1) return;
          this.wipe(this.last, p);
          this.edgeTravel += dist;
          this.dripTravel += dist;
          if (this.edgeTravel > 30 * this.dpr) {
            this.edgeTravel = 0;
            this.pushWater(this.last, p);
          }
          if (this.dripTravel > 52 * this.dpr) {
            this.dripTravel = 0;
            if (Math.random() < 0.75) this.spawnDrip(p);
          }
          this.last = p;
          this.moves += 1;
          if (this.moves % 8 === 0) this.checkCleared();
        });
        const stop = () => {
          if (!this.drawing) return;
          this.drawing = false;
          this.checkCleared();
        };
        this.canvas.addEventListener('pointerup', stop);
        this.canvas.addEventListener('pointercancel', stop);
      }

      open() {
        if (this.root.classList.contains('is-open')) return;
        this.previousFocus = document.activeElement;
        this.root.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        requestAnimationFrame(() => {
          this.paintFog();
          this.root.classList.add('is-open');
          this.root.querySelector('.cwp__close').focus({ preventScroll: true });
        });
      }

      close(remember) {
        if (this.root.hidden) return;
        if (remember && !this.isDesign) {
          const state = store.get(KEY_STATE);
          if (!state || state.status !== 'claimed') store.set(KEY_STATE, { status: 'dismissed', at: Date.now() });
        }
        this.root.classList.remove('is-open');
        document.documentElement.style.overflow = '';
        window.setTimeout(() => { this.root.hidden = true; }, reduceMotion ? 0 : 420);
        if (this.previousFocus && this.previousFocus.focus) this.previousFocus.focus({ preventScroll: true });
      }

      onKey(e) {
        if (e.key === 'Escape') {
          this.close(true);
          return;
        }
        if (e.key !== 'Tab') return;
        const focusable = Array.from(this.sheet.querySelectorAll('button, a[href], input:not([type="hidden"])'))
          .filter((el) => !el.disabled && !el.closest('[hidden]'));
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }

      paintFog() {
        if (this.revealed) return;
        const rect = this.canvas.getBoundingClientRect();
        if (!rect.width) return;
        const d = Math.min(window.devicePixelRatio || 1, 2);
        this.dpr = d;
        const w = Math.round(rect.width * d);
        const h = Math.round(rect.height * d);
        this.canvas.width = w;
        this.canvas.height = h;
        this.dropsCanvas.width = w;
        this.dropsCanvas.height = h;
        const ctx = this.ctx;
        ctx.globalCompositeOperation = 'source-over';
        ctx.globalAlpha = 1;
        ctx.clearRect(0, 0, w, h);

        const base = ctx.createLinearGradient(0, 0, 0, h);
        base.addColorStop(0, 'rgb(240, 244, 236)');
        base.addColorStop(0.6, 'rgb(229, 235, 224)');
        base.addColorStop(1, 'rgb(216, 224, 209)');
        ctx.fillStyle = base;
        ctx.fillRect(0, 0, w, h);

        const rim = ctx.createRadialGradient(w / 2, h * 0.42, w * 0.2, w / 2, h * 0.45, h * 0.75);
        rim.addColorStop(0, 'rgba(255, 255, 255, 0)');
        rim.addColorStop(1, 'rgba(255, 255, 255, 0.35)');
        ctx.fillStyle = rim;
        ctx.fillRect(0, 0, w, h);

        const img = ctx.getImageData(0, 0, w, h);
        const px = img.data;
        for (let i = 0; i < px.length; i += 4) {
          const n = (Math.random() - 0.5) * 18;
          px[i] += n;
          px[i + 1] += n;
          px[i + 2] += n;
        }
        ctx.putImageData(img, 0, 0);

        const mist = Math.round((w * h) / 180);
        for (let i = 0; i < mist; i += 1) {
          const x = Math.random() * w;
          const y = Math.random() * h;
          const r = rand(0.35, 1.1) * d;
          ctx.fillStyle = `rgba(255, 255, 255, ${rand(0.4, 0.9)})`;
          ctx.beginPath();
          ctx.arc(x, y, r, 0, TAU);
          ctx.fill();
          ctx.fillStyle = `rgba(120, 140, 115, ${rand(0.15, 0.3)})`;
          ctx.beginPath();
          ctx.arc(x + r * 0.3, y + r * 0.5, r * 0.45, 0, TAU);
          ctx.fill();
        }

        const beads = Math.round((w * h) / 2600);
        for (let i = 0; i < beads; i += 1) {
          const big = Math.random() < 0.15 ? 1.4 : 1;
          drawBead(ctx, Math.random() * w, Math.pow(Math.random(), 0.7) * h, rand(1.3, 4.2) * d * big, rand(0.7, 1));
        }

        ctx.fillStyle = 'rgba(68, 96, 79, 0.85)';
        ctx.font = `800 ${10 * d}px "Hanken Grotesk", system-ui, sans-serif`;
        ctx.textAlign = 'center';
        if ('letterSpacing' in ctx) ctx.letterSpacing = `${1.4 * d}px`;
        ctx.fillText('WIPE HERE', w / 2, h - 16 * d);
        if ('letterSpacing' in ctx) ctx.letterSpacing = '0px';

        this.brush = this.makeBrush();
      }

      makeBrush() {
        const d = this.dpr;
        const r = Math.round(17 * d);
        const c = document.createElement('canvas');
        c.width = r * 2;
        c.height = r * 2;
        const b = c.getContext('2d');
        const g = b.createRadialGradient(r, r, 0, r, r, r);
        g.addColorStop(0, 'rgba(0, 0, 0, 1)');
        g.addColorStop(0.74, 'rgba(0, 0, 0, 0.95)');
        g.addColorStop(0.92, 'rgba(0, 0, 0, 0.35)');
        g.addColorStop(1, 'rgba(0, 0, 0, 0)');
        b.fillStyle = g;
        b.beginPath();
        b.arc(r, r, r, 0, TAU);
        b.fill();
        b.globalCompositeOperation = 'destination-out';
        for (let i = 0; i < r * 0.6; i += 1) {
          const a = Math.random() * TAU;
          const dist = rand(0.55, 0.95) * r;
          b.fillStyle = `rgba(0, 0, 0, ${rand(0.25, 0.6)})`;
          b.beginPath();
          b.arc(r + Math.cos(a) * dist, r + Math.sin(a) * dist, rand(0.4, 1.1) * d, 0, TAU);
          b.fill();
        }
        this.brushR = r;
        return c;
      }

      point(e) {
        const rect = this.canvas.getBoundingClientRect();
        return { x: (e.clientX - rect.left) * this.dpr, y: (e.clientY - rect.top) * this.dpr };
      }

      wipe(a, b) {
        if (!this.brush) return;
        const ctx = this.ctx;
        const r = this.brushR;
        const dist = Math.hypot(b.x - a.x, b.y - a.y);
        const steps = Math.max(1, Math.ceil(dist / Math.max(2, r * 0.3)));
        ctx.globalCompositeOperation = 'destination-out';
        ctx.globalAlpha = 0.6;
        for (let i = 0; i <= steps; i += 1) {
          const t = i / steps;
          ctx.drawImage(this.brush, a.x + (b.x - a.x) * t - r, a.y + (b.y - a.y) * t - r);
        }
        ctx.globalAlpha = 1;
        ctx.globalCompositeOperation = 'source-over';
      }

      pushWater(a, b) {
        const dx = b.x - a.x;
        const dy = b.y - a.y;
        const len = Math.hypot(dx, dy) || 1;
        const nx = -dy / len;
        const ny = dx / len;
        [-1, 1].forEach((side) => {
          if (Math.random() > 0.65) return;
          const off = this.brushR * rand(0.92, 1.15) * side;
          drawBead(this.ctx, b.x + nx * off, b.y + ny * off, rand(1.4, 3) * this.dpr, rand(0.8, 1));
        });
      }

      spawnDrip(p) {
        const d = this.dpr;
        this.drips.push({
          x: p.x + rand(-0.6, 0.6) * this.brushR,
          y: p.y + this.brushR * 0.6,
          r: rand(1.6, 2.6) * d,
          length: rand(40, 110) * d,
          traveled: 0,
          vy: 0,
          pause: 0
        });
        if (reduceMotion) {
          while (this.drips.length) this.stepDrips(false);
          return;
        }
        if (!this.anim) this.anim = requestAnimationFrame(() => this.tick());
      }

      tick() {
        this.anim = null;
        if (this.revealed) {
          this.drips = [];
          return;
        }
        this.stepDrips(true);
        if (this.drips.length) this.anim = requestAnimationFrame(() => this.tick());
      }

      stepDrips(render) {
        const ctx = this.ctx;
        const dc = this.dctx;
        const d = this.dpr;
        const h = this.canvas.height;
        if (render) dc.clearRect(0, 0, this.dropsCanvas.width, this.dropsCanvas.height);
        this.drips = this.drips.filter((drip) => {
          if (drip.pause > 0) {
            drip.pause -= 1;
          } else {
            drip.vy = Math.min(drip.vy + 0.06 * d, 2.2 * d);
            if (Math.random() < 0.02) drip.pause = Math.round(rand(8, 30));
            const fromX = drip.x;
            const fromY = drip.y;
            drip.x += (Math.random() - 0.5) * 0.35 * d;
            drip.y += drip.vy;
            drip.traveled += drip.vy;
            ctx.globalCompositeOperation = 'destination-out';
            ctx.globalAlpha = 1;
            ctx.strokeStyle = '#000';
            ctx.lineCap = 'round';
            ctx.lineWidth = drip.r * 1.25 * Math.max(0.55, 1 - drip.traveled / (drip.length * 1.6));
            ctx.beginPath();
            ctx.moveTo(fromX, fromY);
            ctx.lineTo(drip.x, drip.y);
            ctx.stroke();
            ctx.globalAlpha = 1;
            ctx.globalCompositeOperation = 'source-over';
          }
          if (drip.traveled >= drip.length || drip.y > h - drip.r) {
            drawBead(ctx, drip.x, drip.y, drip.r * 1.15, 1);
            return false;
          }
          if (render) drawBead(dc, drip.x, drip.y, drip.r * 1.15, 1);
          return true;
        });
      }

      checkCleared() {
        if (this.revealed || !this.canvas.width) return;
        const { width: w, height: h } = this.canvas;
        const data = this.ctx.getImageData(0, 0, w, h).data;
        let clear = 0;
        let total = 0;
        for (let i = 3; i < data.length; i += 32) {
          total += 1;
          if (data[i] < 50) clear += 1;
        }
        if (total && clear / total > 0.42) this.reveal(false);
      }

      reveal(fromKeyboard) {
        if (this.revealed) return;
        this.revealed = true;
        this.canvas.classList.add('is-cleared');
        this.dropsCanvas.classList.add('is-cleared');
        const label = this.prize.label;
        this.submit.disabled = false;
        this.submit.textContent = fill(this.root.dataset.claimLabel, label);
        this.live.textContent = fill(this.root.dataset.liveFound, label);
        const button = this.root.querySelector('[data-cwp-reveal]');
        if (button) button.remove();
        if (fromKeyboard) this.email.focus();
      }

      onSubmit(e) {
        this.error.textContent = '';
        if (!this.revealed || this.posting) {
          e.preventDefault();
          return;
        }
        if (!this.email.checkValidity()) {
          e.preventDefault();
          this.error.textContent = this.root.dataset.errorEmail;
          this.email.focus();
          return;
        }
        this.tags.value = `newsletter,scratch-popup,scratch-${this.prize.amount}-off`;
        store.set(KEY_PENDING, { code: this.prize.code, at: Date.now() });
        if (this.form.target === '_self') return;
        if (this.form.hasAttribute('data-cptcha') && !this.form.hasAttribute('data-hcaptcha-bound') && !this.waitedForCaptcha) {
          e.preventDefault();
          this.waitForCaptcha();
          return;
        }
        this.posting = true;
        window.setTimeout(() => { this.submit.disabled = true; }, 0);
        this.timeout = window.setTimeout(() => this.onTimeout(), 60000);
      }

      waitForCaptcha() {
        this.waitedForCaptcha = true;
        this.submit.disabled = true;
        const forms = window.Shopify && window.Shopify.ce_forms;
        if (forms && typeof forms.bindForm === 'function') {
          forms.bindForm(this.form);
        } else {
          this.email.dispatchEvent(new FocusEvent('focusin', { bubbles: true }));
          this.email.focus();
        }
        let tries = 0;
        const check = () => {
          if (this.form.hasAttribute('data-hcaptcha-bound') || tries > 40) {
            this.submit.disabled = false;
            this.form.requestSubmit();
            return;
          }
          tries += 1;
          window.setTimeout(check, 125);
        };
        check();
      }

      onTimeout() {
        if (!this.posting) return;
        this.posting = false;
        store.remove(KEY_PENDING);
        this.submit.disabled = false;
        this.error.textContent = this.root.dataset.errorNetwork;
      }

      submitTopLevel() {
        this.submit.disabled = false;
        this.form.target = '_self';
        this.form.requestSubmit();
      }

      onFrameLoad() {
        if (!this.posting) return;
        let href = '';
        let doc = null;
        try {
          href = this.frame.contentWindow.location.href;
          doc = this.frame.contentDocument;
        } catch (e) {}
        if (href === 'about:blank') return;
        this.posting = false;
        window.clearTimeout(this.timeout);

        const posted = href.includes('customer_posted=true')
          || (doc && doc.querySelector('[data-cwp-posted="true"]'));
        if (posted) {
          store.remove(KEY_PENDING);
          this.showWon();
          return;
        }

        const serverError = doc && doc.querySelector('[data-cwp-server-error]');
        if (serverError && serverError.textContent.trim()) {
          store.remove(KEY_PENDING);
          this.submit.disabled = false;
          this.error.textContent = serverError.textContent.trim();
          return;
        }

        this.submitTopLevel();
      }

      showWon() {
        const { code, label } = this.prize;
        this.revealed = true;
        this.canvas.classList.add('is-cleared');
        this.dropsCanvas.classList.add('is-cleared');
        store.set(KEY_STATE, { status: 'claimed', at: Date.now() });
        this.root.querySelector('[data-cwp-title]').textContent = fill(this.root.dataset.wonHeading, label);
        const text = this.root.querySelector('[data-cwp-text]');
        if (this.root.dataset.wonText) text.textContent = fill(this.root.dataset.wonText, label);
        this.root.querySelector('[data-cwp-claim]').hidden = true;
        this.root.querySelector('[data-cwp-foot]').hidden = true;
        const button = this.root.querySelector('[data-cwp-reveal]');
        if (button) button.remove();
        this.root.querySelector('[data-cwp-code]').textContent = code;
        const redirect = this.root.dataset.redirect || '/';
        const base = (this.root.dataset.root || '/').replace(/\/$/, '');
        const shop = this.root.querySelector('[data-cwp-shop]');
        shop.href = `${base}/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(redirect)}`;
        this.root.querySelector('[data-cwp-shop-label]').textContent = fill(this.root.dataset.shopLabel, label);
        this.root.querySelector('[data-cwp-won]').hidden = false;
        shop.focus({ preventScroll: true });
      }

      async copy(button) {
        const text = button.textContent;
        try {
          await navigator.clipboard.writeText(this.prize.code);
          button.textContent = this.root.dataset.copiedLabel;
          window.setTimeout(() => { button.textContent = text; }, 1800);
        } catch (e) {}
      }
    }

    const init = () => {
      document.querySelectorAll('[data-cwp]').forEach((root) => {
        if (root.cwp) return;
        root.cwp = new WipePopup(root);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calmyr-worlds"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (customElements.get('calmyr-worlds')) return;
  class CalmyrWorlds extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var self = this;
      this.viewport = this.querySelector('.cw__viewport');
      this.cards = Array.prototype.slice.call(this.querySelectorAll('.cw__card'));
      this.dots = Array.prototype.slice.call(this.querySelectorAll('.cw__dot'));
      this.arrows = Array.prototype.slice.call(this.querySelectorAll('.cw__arrow'));
      this.live = this.querySelector('.cw__sr');
      this.n = this.cards.length;
      if (!this.n) return;
      this.reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.active = Math.min(this.n - 1, Math.max(0, parseInt(this.dataset.start, 10) || 0));
      this.render(false);

      /* one-time fan-out on first view */
      if (!this.reduce && 'IntersectionObserver' in window && this.n > 1) {
        this.classList.add('is-pre');
        this.io = new IntersectionObserver(function (entries) {
          if (!entries.some(function (e) { return e.isIntersecting; })) return;
          self.io.disconnect();
          self.classList.add('is-fanning');
          requestAnimationFrame(function () {
            self.classList.remove('is-pre');
            setTimeout(function () { self.classList.remove('is-fanning'); }, 700);
          });
        }, { threshold: 0.35 });
        this.io.observe(this.viewport);
      }

      this.arrows.forEach(function (a) {
        a.addEventListener('click', function () { self.go(self.active + parseInt(a.getAttribute('data-dir'), 10)); });
      });
      this.dots.forEach(function (d) {
        d.addEventListener('click', function () { self.go(parseInt(d.getAttribute('data-go'), 10)); });
      });
      this.cards.forEach(function (c, i) {
        c.addEventListener('click', function (e) {
          if (self.dragMoved) { e.preventDefault(); e.stopPropagation(); return; }
          if (i !== self.active) { e.preventDefault(); self.go(i); }
        }, true);
      });
      this.querySelectorAll('.cw__cta').forEach(function (btn) {
        btn.addEventListener('click', function () { self.choose(btn.getAttribute('data-world')); });
      });
      this.viewport.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); self.go(self.active + 1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); self.go(self.active - 1); }
      });

      /* drag / swipe: cards follow the pointer, then settle */
      this.onDown = function (e) {
        if (e.button !== undefined && e.button !== 0) return;
        self.drag = { x: e.clientX, y: e.clientY, t: performance.now(), dx: 0, lock: null, id: e.pointerId };
        self.dragMoved = false;
      };
      this.onMove = function (e) {
        var d = self.drag;
        if (!d || e.pointerId !== d.id) return;
        var dx = e.clientX - d.x, dy = e.clientY - d.y;
        if (d.lock === null) {
          if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
          d.lock = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
          if (d.lock === 'x') {
            self.classList.add('is-dragging');
            try { self.viewport.setPointerCapture(d.id); } catch (err) {}
          }
        }
        if (d.lock !== 'x') return;
        self.dragMoved = true;
        /* resist past the first / last card */
        var atEdge = (self.active === 0 && dx > 0) || (self.active === self.n - 1 && dx < 0);
        d.dx = atEdge ? dx * 0.35 : dx;
        d.v = dx / Math.max(1, performance.now() - d.t);
        self.render(false, d.dx / self.step());
      };
      this.onUp = function (e) {
        var d = self.drag;
        if (!d || e.pointerId !== d.id) return;
        self.drag = null;
        self.classList.remove('is-dragging');
        if (d.lock !== 'x') return;
        var step = self.step(), move = 0;
        if (Math.abs(d.dx) > step * 0.22 || Math.abs(d.v || 0) > 0.45) move = d.dx < 0 ? 1 : -1;
        self.go(self.active + move, true);
        setTimeout(function () { self.dragMoved = false; }, 0);
      };
      this.viewport.addEventListener('pointerdown', this.onDown);
      this.viewport.addEventListener('pointermove', this.onMove);
      this.viewport.addEventListener('pointerup', this.onUp);
      this.viewport.addEventListener('pointercancel', this.onUp);
    }
    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      this._ready = false;
    }
    step() {
      if (window.matchMedia('(min-width: 861px)').matches) return 372;
      return this.cards[this.active].offsetWidth + 14;
    }
    render(announce, offset) {
      var self = this;
      offset = offset || 0;
      this.cards.forEach(function (c, i) {
        var pos = i - self.active;
        c.setAttribute('data-pos', String(pos));
        c.style.setProperty('--pos', (pos + offset).toFixed(4));
        c.classList.toggle('is-far', Math.abs(pos) > 1 && Math.abs(pos + offset) > 1.2);
        c.setAttribute('aria-hidden', pos === 0 ? 'false' : 'true');
        var cta = c.querySelector('.cw__cta');
        if (cta) cta.tabIndex = pos === 0 ? 0 : -1;
      });
      this.dots.forEach(function (d, i) {
        d.classList.toggle('is-on', i === self.active);
        if (i === self.active) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
      if (this.arrows.length === 2) {
        this.arrows[0].disabled = this.active === 0;
        this.arrows[1].disabled = this.active === this.n - 1;
      }
      if (announce && this.live) {
        var name = this.cards[this.active].querySelector('.cw__name');
        this.live.textContent = (name ? name.textContent : '') + ', ' + (this.active + 1) + ' / ' + this.n;
      }
    }
    go(i) {
      var next = Math.max(0, Math.min(this.n - 1, i));
      this.active = next;
      this.render(true);
    }
    /* select the world in the Calmyr hero buy box, then scroll up to it */
    choose(name) {
      var key = (name || '').trim().toLowerCase();
      var hero = document.querySelector('calmyr-hero');
      var btns = document.querySelectorAll('calmyr-hero .ch-world, .ch-world');
      var target = null;
      for (var i = 0; i < btns.length; i++) {
        if (btns[i].textContent.trim().toLowerCase().indexOf(key) !== -1) { target = btns[i]; break; }
      }
      if (target && !target.disabled && !target.classList.contains('is-on')) target.click();
      var dest = hero || document.querySelector('product-form, form[action*="/cart/add"]');
      if (!dest) return;
      var head = 0;
      var hs = document.querySelectorAll('.shopify-section-group-header-group, sticky-header, .header-wrapper');
      for (var j = 0; j < hs.length; j++) {
        var cs = getComputedStyle(hs[j]);
        if (cs.position === 'sticky' || cs.position === 'fixed') head = Math.max(head, hs[j].getBoundingClientRect().bottom);
      }
      var y = window.scrollY + dest.getBoundingClientRect().top - head - 12;
      window.scrollTo({ top: Math.max(0, y), behavior: this.reduce ? 'auto' : 'smooth' });
    }
  }
  customElements.define('calmyr-worlds', CalmyrWorlds);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('calmyr-footer')) return;
  class CalmyrFooter extends HTMLElement {
    connectedCallback() {
      if (!('IntersectionObserver' in window)) return;
      this.classList.add('js');
      // after a newsletter post Shopify reloads the page: show the result straight away
      if (location.hash === '#CalmyrFooterNews' || this.querySelector('.cft__msg')) {
        this.classList.add('is-in', 'is-live');
        return;
      }
      // reveal once; keep the float running only while the footer is on screen
      this.io = new IntersectionObserver((entries) => {
        const on = entries[0].isIntersecting;
        if (on) this.classList.add('is-in');
        this.classList.toggle('is-live', on);
      }, { rootMargin: '0px 0px -8% 0px' });
      this.io.observe(this);
    }
    disconnectedCallback() {
      if (this.io) this.io.disconnect();
    }
  }
  customElements.define('calmyr-footer', CalmyrFooter);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["track-order"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('calmyr-track')) return;
  class CalmyrTrack extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('.ctr__tab')];
      this.tablist = this.querySelector('.ctr__tabs');
      this.tabs.forEach((t, i) => {
        t.addEventListener('click', () => this.select(i, false));
        t.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault();
            this.select(i === 0 ? 1 : 0, true);
          }
        });
      });

      // tracking number → open the carrier tracker in a new tab
      const num = this.querySelector('.ctr__num');
      if (num) {
        num.addEventListener('submit', (e) => {
          e.preventDefault();
          const input = num.querySelector('input');
          const hint = num.querySelector('.ctr__hint');
          const v = input.value.replace(/\s+/g, '').trim();
          if (!v) {
            input.focus();
            if (hint) hint.classList.add('is-warn');
            return;
          }
          if (hint) hint.classList.remove('is-warn');
          const tpl = this.dataset.url || 'https://t.17track.net/en#nums={number}';
          window.open(tpl.replace('{number}', encodeURIComponent(v)), '_blank', 'noopener');
        });
      }

      // after the request form posts, Shopify reloads the page: show the result
      const result = this.querySelector('.ctr__done, .ctr__err');
      if (result) {
        result.scrollIntoView({ block: 'center' });
        if (result.classList.contains('ctr__done')) result.focus({ preventScroll: true });
      }

      if (!('IntersectionObserver' in window) || result) return;
      this.classList.add('js');
      this.io = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) { this.classList.add('is-in'); this.io.disconnect(); }
      }, { threshold: 0.1 });
      this.io.observe(this);
    }
    select(i, focus) {
      this.tabs.forEach((t, j) => {
        const on = i === j;
        t.setAttribute('aria-selected', on);
        t.tabIndex = on ? 0 : -1;
        const p = this.querySelector('#' + t.getAttribute('aria-controls'));
        if (!p) return;
        if (on && p.hidden) {
          p.hidden = false;
          p.classList.remove('is-enter'); void p.offsetWidth; p.classList.add('is-enter');
        } else if (!on) {
          p.hidden = true;
        }
      });
      this.tablist.classList.toggle('is-2', i === 1);
      if (focus) this.tabs[i].focus();
    }
    disconnectedCallback() { if (this.io) this.io.disconnect(); }
  }
  customElements.define('calmyr-track', CalmyrTrack);
})();

  } catch(e) { console.error(e); }
})();
})();
